/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTouchpad: {
  name: 'touchpad';
  data: string;
} = {
  name: 'touchpad',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 4A1.5 1.5 0 0 1 2 2.5h12A1.5 1.5 0 0 1 15.5 4v8a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 12V4Zm8 8.5H14a.5.5 0 0 0 .5-.5v-1.5h-6v2Zm-1-2v2H2a.5.5 0 0 1-.5-.5v-1.5h6Zm.5-1h6.5V4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v5.5H8Z" fill="currentColor"/></svg>`,
};
